/** @jsx jsx */
import { jsx, InterpolationWithTheme } from '@emotion/core';
import React from 'react';
import useTranslate from 'hooks/useTranslate';
import styles from './styles';
import { Theme } from 'features/Theme';

interface PropTypes {
  containerStyles: InterpolationWithTheme<Theme>;
  buttonContainerStyle: InterpolationWithTheme<Theme>;
}

const DemoWallets: React.FC<PropTypes> = props => {
  const { containerStyles, buttonContainerStyle } = props;
  const t = useTranslate();

  return (
    <React.Fragment>
      <div css={containerStyles}>
        <div css={buttonContainerStyle}>
          <a
            href={t('demoWallets.appleUrl')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button css={styles.button}>
              <img
                src={
                  'https://id-idss.s3.amazonaws.com/assets/add_to_apple_wallet.png'
                }
                css={styles.img}
                alt="Apple Demo Wallet"
              />
            </button>
          </a>
        </div>
        <div css={buttonContainerStyle}>
          <a
            href={t('demoWallets.googleUrl')}
            target="_blank"
            rel="noopener noreferrer"
          >
            <button css={styles.button}>
              <img
                src={`https://id-idss.s3.amazonaws.com/assets/add_to_google_pay.png`}
                css={styles.img}
                alt="Google Demo Wallet"
              />
            </button>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DemoWallets;
